
/* EC Predictive Search */
(function() {
  var searchWrap = document.querySelector('.ec-search-wrap');
  if (!searchWrap) return;
  
  var input = searchWrap.querySelector('.ec-header__search-input');
  var dropdown = searchWrap.querySelector('.ec-search-dropdown');
  var clearBtn = searchWrap.querySelector('.ec-search-clear');
  var timer = null;
  var cache = {};
  var activeIdx = -1;
  var results = [];
  
  var popularSearches = [
    'Convection Ovens', 'Fridges', 'Wine Glasses', 'Cutlery',
    'Dining Chairs', 'Fryers', 'Coffee Machines', 'Plates'
  ];
  
  function showPopular() {
    var html = '<div class="ec-search-popular"><div class="ec-search-popular__title">Popular Searches</div><div class="ec-search-popular__tags">';
    popularSearches.forEach(function(s) {
      html += '<span class="ec-search-popular__tag" data-query="' + s + '">' + s + '</span>';
    });
    html += '</div></div>';
    dropdown.innerHTML = html;
    dropdown.classList.add('ec-search--open');
    
    dropdown.querySelectorAll('.ec-search-popular__tag').forEach(function(tag) {
      tag.addEventListener('click', function() {
        input.value = this.dataset.query;
        searchWrap.classList.add('has-value');
        doSearch(this.dataset.query);
      });
    });
  }
  
  function doSearch(q) {
    if (q.length < 2) { showPopular(); return; }
    
    if (cache[q]) { renderResults(q, cache[q]); return; }
    
    dropdown.innerHTML = '<div class="ec-search-loading">Searching</div>';
    dropdown.classList.add('ec-search--open');
    
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        cache[q] = data;
        renderResults(q, data);
      })
      .catch(function() {
        dropdown.innerHTML = '<div class="ec-search-empty"><div class="ec-search-empty__text">Something went wrong</div></div>';
      });
  }
  
  function highlight(text, query) {
    if (!text || !query) return text || '';
    var re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return text.replace(re, '<mark>$1</mark>');
  }
  
  function renderResults(q, data) {
    var res = data.resources.results;
    var queries = res.queries || [];
    var products = res.products || [];
    var collections = res.collections || [];
    results = [];
    activeIdx = -1;
    
    if (!queries.length && !products.length && !collections.length) {
      dropdown.innerHTML = '<div class="ec-search-empty"><div class="ec-search-empty__text">No results for "' + q + '"</div><div class="ec-search-empty__suggestions">Try different keywords or browse our categories</div></div>' +
        '<a href="/collections" class="ec-search-viewall">Browse All Categories</a>';
      dropdown.classList.add('ec-search--open');
      return;
    }
    
    var html = '';
    
    // Suggestions
    if (queries.length) {
      html += '<div class="ec-search-section"><div class="ec-search-section__title">Suggestions</div></div>';
      html += '<ul class="ec-search-suggestions">';
      queries.forEach(function(item, i) {
        html += '<li class="ec-search-suggestion" data-idx="' + results.length + '" data-url="/search?q=' + encodeURIComponent(item.text) + '">';
        html += '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
        html += '<span class="ec-search-suggestion__text">' + highlight(item.text, q) + '</span>';
        html += '</li>';
        results.push({ url: '/search?q=' + encodeURIComponent(item.text) });
      });
      html += '</ul>';
    }
    
    // Collections
    if (collections.length) {
      html += '<div class="ec-search-section"><div class="ec-search-section__title">Categories</div></div>';
      html += '<ul class="ec-search-collections">';
      collections.forEach(function(col) {
        html += '<li class="ec-search-collection" data-idx="' + results.length + '" data-url="' + col.url + '">';
        html += '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
        html += '<span class="ec-search-collection__text">' + highlight(col.title, q) + '</span>';
        html += '</li>';
        results.push({ url: col.url });
      });
      html += '</ul>';
    }
    
    // Products
    if (products.length) {
      html += '<div class="ec-search-section"><div class="ec-search-section__title">Products</div></div>';
      html += '<ul class="ec-search-products">';
      products.forEach(function(p) {
        var img = p.image ? p.image.replace(/(\.\w+)$/, '_120x$1') : '';
        var price = p.price ? '£' + (parseFloat(p.price)/100).toFixed(2) : '';
        var compare = p.compare_at_price ? '£' + (parseFloat(p.compare_at_price)/100).toFixed(2) : '';
        var onSale = p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price);
        var vendor = p.vendor || '';
        
        html += '<li class="ec-search-product" data-idx="' + results.length + '" data-url="' + p.url + '">';
        html += '<img class="ec-search-product__img" src="' + img + '" alt="" loading="lazy">';
        html += '<div class="ec-search-product__info">';
        html += '<div class="ec-search-product__title">' + highlight(p.title, q) + '</div>';
        if (vendor) html += '<div class="ec-search-product__vendor">' + vendor + '</div>';
        html += '<div class="ec-search-product__meta">';
        html += '<span class="ec-search-product__price">' + price + '</span>';
        if (onSale) {
          html += '<span class="ec-search-product__compare">' + compare + '</span>';
          html += '<span class="ec-search-product__badge">Sale</span>';
        }
        html += '</div></div></li>';
        results.push({ url: p.url });
      });
      html += '</ul>';
    }
    
    html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="ec-search-viewall">View all results for "' + q + '" →</a>';
    
    dropdown.innerHTML = html;
    dropdown.classList.add('ec-search--open');
    
    // Click handlers
    dropdown.querySelectorAll('[data-url]').forEach(function(el) {
      el.addEventListener('click', function() {
        window.location.href = this.dataset.url;
      });
    });
  }
  
  // Input events
  input.addEventListener('input', function() {
    var q = this.value.trim();
    searchWrap.classList.toggle('has-value', q.length > 0);
    clearTimeout(timer);
    timer = setTimeout(function() { doSearch(q); }, 250);
  });
  
  input.addEventListener('focus', function() {
    var q = this.value.trim();
    if (q.length >= 2) { doSearch(q); }
    else { showPopular(); }
  });
  
  // Clear
  if (clearBtn) {
    clearBtn.addEventListener('click', function(e) {
      e.preventDefault();
      input.value = '';
      searchWrap.classList.remove('has-value');
      input.focus();
      showPopular();
    });
  }
  
  // Keyboard navigation
  input.addEventListener('keydown', function(e) {
    if (!dropdown.classList.contains('ec-search--open')) return;
    var items = dropdown.querySelectorAll('[data-idx]');
    if (!items.length) return;
    
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = Math.min(activeIdx + 1, items.length - 1);
      items.forEach(function(el, i) { el.classList.toggle('ec-search--active', i === activeIdx); });
      items[activeIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = Math.max(activeIdx - 1, 0);
      items.forEach(function(el, i) { el.classList.toggle('ec-search--active', i === activeIdx); });
      items[activeIdx].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && activeIdx >= 0 && results[activeIdx]) {
      e.preventDefault();
      window.location.href = results[activeIdx].url;
    } else if (e.key === 'Escape') {
      dropdown.classList.remove('ec-search--open');
      input.blur();
    }
  });
  
  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!searchWrap.contains(e.target)) {
      dropdown.classList.remove('ec-search--open');
    }
  });
})();
